import { ref, computed, Ref } from 'vue'

export default (last: Ref): [Ref<boolean>, Ref<string>] => {
  const collapse = ref(true)
  const height = computed(() => {
    const len = last.value.length
    if (len > 4) {
      return (collapse.value ? 4 : len) * 48 + 'px'
    } else {
      return len * 48 + 'px'
    }
  })
  return [collapse, height]
}
